export const convertTime12to24 = (time12h) => {
  if (!time12h) return "";

  const [time, modifier = ""] = time12h.split(" ");
  if (!time) return "";

  let [hours, minutes] = time.split(":");
  if (!hours || !minutes) return "";

  if (hours === "12" && modifier.toLowerCase() === "am") {
    hours = "00";
  }
  if (modifier.toLowerCase() === "pm") {
    hours = String(parseInt(hours, 10) + 12);
  }

  return `${hours}:${minutes}`;
};
